import { render, staticRenderFns } from "./fibonacci-calculator.vue?vue&type=template&id=0c6c81b7&scoped=true"
import script from "./fibonacci-calculator.vue?vue&type=script&lang=js"
export * from "./fibonacci-calculator.vue?vue&type=script&lang=js"
import style0 from "./fibonacci-calculator.vue?vue&type=style&index=0&id=0c6c81b7&prod&lang=css"
import style1 from "./fibonacci-calculator.vue?vue&type=style&index=1&id=0c6c81b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c81b7",
  null
  
)

export default component.exports